<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="required" type="checkbox" value="{{fieldOptions.validate.required}}"
           [(ngModel)]="fieldOptions.validate.required">
    <span><b>Required</b></span>
  </label>
</div>